/* Lucky 8th real-winner toast. Polls the theme feed; never simulates winners. */
(function () {
  var root = document.getElementById('l8-toast-root');
  var tpl = document.getElementById('l8-toast-tpl');
  if (!root || !tpl || window.__lucky8Toast) return;
  window.__lucky8Toast = true;

  var SEEN_KEY = 'lucky8_seen_v1';
  var pollMs = (parseInt(root.getAttribute('data-poll'), 10) || 45) * 1000;
  var windowS = parseInt(root.getAttribute('data-window'), 10) || 21600;
  var stopAt = (parseInt(root.getAttribute('data-stop'), 10) || 0) * 1000;
  var base = root.getAttribute('data-root') || '/';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var intervalId = null;
  var showing = false;

  function getSeen() {
    try {
      var list = JSON.parse(window.localStorage.getItem(SEEN_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function markSeen(id) {
    try {
      var list = getSeen();
      if (list.indexOf(id) === -1) list.push(id);
      window.localStorage.setItem(SEEN_KEY, JSON.stringify(list.slice(-50)));
    } catch (e) {}
  }

  function hide(card) {
    if (!card || !card.parentNode) return;
    card.classList.remove('is-in');
    card.classList.add('is-out');
    setTimeout(function () {
      if (card.parentNode) card.parentNode.removeChild(card);
      showing = false;
    }, reduceMotion ? 0 : 420);
  }

  function show() {
    showing = true;
    var frag = tpl.content.cloneNode(true);
    var card = frag.querySelector('.l8-toast');
    root.appendChild(frag);
    card = root.lastElementChild;

    var dismissTimer = null;
    var remaining = 8000;
    var startedAt = 0;
    function startTimer() {
      startedAt = Date.now();
      dismissTimer = setTimeout(function () { hide(card); }, remaining);
    }
    function pauseTimer() {
      clearTimeout(dismissTimer);
      remaining = Math.max(1500, remaining - (Date.now() - startedAt));
    }
    card.addEventListener('mouseenter', pauseTimer);
    card.addEventListener('mouseleave', startTimer);
    card.addEventListener('focusin', pauseTimer);
    card.addEventListener('focusout', startTimer);
    card.querySelector('.l8-toast__close').addEventListener('click', function () {
      clearTimeout(dismissTimer);
      hide(card);
    });

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { card.classList.add('is-in'); });
    });
    startTimer();
  }

  function readFeed(html) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector('script[data-lucky8-feed]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function check() {
    if (document.hidden || showing) return;
    if (stopAt && Date.now() > stopAt) {
      clearInterval(intervalId);
      return;
    }
    var bucket = Math.floor(Date.now() / pollMs);
    var url = base + '?sections=lucky8-winner-feed&l8=' + bucket;
    fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var feed = readFeed(data && data['lucky8-winner-feed']);
        if (!feed || !feed.winner || !feed.winner.order || !feed.winner.won_at) return;
        var age = feed.now - feed.winner.won_at;
        if (age < 0 || age > windowS) return;
        var id = 'order-' + feed.winner.order;
        if (getSeen().indexOf(id) !== -1) return;
        markSeen(id);
        show();
      })
      .catch(function () {});
  }

  setTimeout(check, 4000);
  intervalId = setInterval(check, pollMs);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) check();
  });
})();
